import { ArrowLeft } from 'lucide-react';

interface VolverButtonProps {
  /** Acción de navegación. El componente no decide el destino: la regla de "subir un nivel"
   *  vive en quien lo usa. */
  readonly onClick: () => void;
  /** Texto alternativo cuando "Volver" no basta (ej: "Volver al balance"). */
  readonly label?: string;
  readonly className?: string;
  /** Marca para que el recorrido de bienvenida pueda resaltar este botón. */
  readonly dataTour?: string;
}

export const VolverButton: React.FC<VolverButtonProps> = ({ onClick, label = 'Volver', className = '', dataTour }) => (
  <button
    type="button"
    onClick={onClick}
    data-tour={dataTour}
    className={`inline-flex items-center gap-2 text-sm font-semibold text-slate-600 hover:text-slate-900 transition-colors ${className}`}
  >
    <ArrowLeft className="w-4 h-4" />
    {label}
  </button>
);
